import React from 'react';
import {observer} from 'mobx-react';
import './spirit.scss';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    store: FrameBuilderStore;
};

export const Spirit = observer(({store}: Props) => {
    if (!store.hasSpirit) return null;

    return (
        <div className="spirit-container">
            {store.spiritSides.map(({outer, inner}, index) => (
                <div
                    key={index}
                    className="outer"
                    style={outer}
                >
                    <div
                        className="inner"
                        style={inner}
                    />
                </div>
            ))}
        </div>
    );
});
